var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.menuName || "selectSticker", {
    tag: "component",
    attrs: {
      dataInstagramDefault: _vm.dataInstagramDefault,
      stickers: _vm.stickers,
      pagesSelectedIncludeConciergerie: _vm.pagesSelectedIncludeConciergerie,
    },
    on: { addSticker: _vm.addSticker, changeMenu: _vm.changeMenu },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }